<template>
   <div class="tabulation">
      <el-card class="chart-card">
         <div class="grabble" @keyup.enter="searchBtn">
            <el-input class="hunt" v-model="productName" placeholder="请输入产品名称" size="large" clearable />
            <el-input class="hunt" v-model="productCode" placeholder="请输入产品编码" size="large" clearable />
            <el-select class="hunt" v-model="status" placeholder="请选择状态" size="large" clearable>
               <el-option label="停用" :value="0" style="width:100%; text-align-last: center;" />
               <el-option label="启用" :value="1" style="width:100%; text-align-last: center;" />
            </el-select>
            <el-button style="margin-left: 10px" type="primary" size="large" @click="searchBtn" :loading="formative">
               <el-icon class="cancelgu">
                  <Search />
               </el-icon>搜索
            </el-button>
         </div>

         <div class="hint">统计 : {{ altogether }}条</div>

         <div class="feature-btn">
            <el-button style="margin-left: 10px" type="primary" size="default" @click="append">
               <el-icon class="cancelgu">
                  <Plus />
               </el-icon>添加
            </el-button>
         </div>

			<el-table ref="tableRef" v-loading="tableLoading" :data="filterTableData" style="width: 100%" row-key="id" border 
            scrollbar-always-on :header-cell-style="{ background: '#F5F7FA' }" :empty-text="texts">
            <el-table-column align="center" label="ID" prop="id" width="100" :show-overflow-tooltip="true" />
            <el-table-column label="产品名称" prop="productName" width="250" align="center" :show-overflow-tooltip="true" />
            <el-table-column align="center" label="产品编码" prop="productCode" width="250" :show-overflow-tooltip="true" />
            <el-table-column label="年度费用" prop="annualFee" align="center"  />
            <el-table-column label="工会补助金额" prop="unionSubsidy" align="center"  />
            <el-table-column label="会员支付金额" prop="memberFee" align="center"  />
            <el-table-column label="状态" align="center">
               <template #default="scope">
                  {{ formatStatus(scope.row.status) }}
               </template>
            </el-table-column>
            <el-table-column label="排序" prop="sort" align="center" />
            <el-table-column label="创建时间" align="center" width="250" :show-overflow-tooltip="true">
               <template #default="scope">
                  {{ formatTime(scope.row.createTime) }}
               </template>
            </el-table-column>
            <el-table-column label="操作" align="center">
               <template #default="scope">
						<el-button type="primary" link @click.stop="copyreader(scope.row)" class="bulur">
                     <el-icon class="cancel">
                        <EditPen />
                     </el-icon>编辑
                  </el-button>
               </template>
            </el-table-column>
         </el-table>
      </el-card>
   </div>
</template>

<script setup>
import { ref, onMounted, onActivated, nextTick } from "vue";
import { useRouter } from "vue-router";
import { EditPen, Plus, Search } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import moments from "moment";
import qs from "qs";
import { queryProductList } from "../../utils/api";

const router = useRouter();
const formative = ref(false);
			const tableLoading = ref(true);
			const tableRef = ref(null);
			const refreshTableLayout = () => nextTick(() => tableRef.value?.doLayout?.());
const texts = ref("加载中");
const altogether = ref(0);
const filterTableData = ref([]);

const productCode = ref("");
const productName = ref("");
const status = ref("");

const formatTime = (timestamp) => {
   if (typeof timestamp === "number") {
      return moments(timestamp * 1000).format("YYYY-MM-DD HH:mm:ss");
   }
   return timestamp || "-";
};

const formatStatus = (value) => {
   const statusMap = {
      0: "停用",
      1: "启用",
   };
   return statusMap[value] || "-";
};

const buildParams = () => {
   return {
      productCode: productCode.value,
      productName: productName.value,
      status: status.value,
   };
};

const list = () => {
			tableLoading.value = true;
			altogether.value = 0;
   texts.value = "加载中";
   queryProductList(qs.stringify(buildParams())).then((res) => {
      const data = res.data;
      if (data.code == 0) {
         const listData = Array.isArray(data.data) ? data.data : data.data.list || [];
         filterTableData.value = listData;
         altogether.value = listData.length;
			texts.value = filterTableData.value.length === 0 ? "暂无数据" : "";
      } else {
         texts.value = "暂无数据";
         ElMessage({
            message: data.msg,
            type: "error",
            center: true,
         });
      }
   }).catch(() => {
      texts.value = "暂无数据";
      ElMessage({
         message: "获取保障产品列表失败",
         type: "error",
         center: true,
      });
   }).finally(() => {
      formative.value = false;
			tableLoading.value = false;
			refreshTableLayout();
   });
};

const searchBtn = () => {
   formative.value = true;
   list();
};

const copyreader = (row) => {
   sessionStorage.setItem("mutualInsuranceProduct", JSON.stringify(row));
   router.push({
      path: "/upSafeguardProduct",
      query: {
         id: row.id,
      },
   });
};

const append = () => {
   router.push("/addSafeguardProduct");
};

onMounted(() => {
   list();
});

onActivated(() => {
   list();
});
</script>

<style lang="scss" scoped>
.chart-card::-webkit-scrollbar {
   display: none;
}

.chart-card {
   height: calc(100vh - 145px);
   overflow: auto;
}

::v-deep .el-table__empty-block {
   border-bottom: 1px solid #EBEEF5 !important;
}

.hint {
   font-size: 14px;
   color: #909399;
   margin-bottom: 15px;
}

.feature-btn {
   display: flex;
   justify-content: flex-end;
   margin-bottom: 15px;
}

::v-deep .el-table__body {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

::v-deep .el-table__header {
   margin-top: 0 !important;
   margin-bottom: 0 !important;
}

.grabble {
   width: 100%;
   margin: 20px 0 15px 0;
   display: flex;
   align-items: center;
   flex-wrap: wrap;
   row-gap: 10px;

   .hunt {
      width: 15%;
      min-width: 160px;
      margin-right: 10px;
   }
}

.cancel {
   margin-right: 5px;
   font-weight: 400;
}

.cancelgu {
   margin-right: 6px;
   font-weight: bold;
}

.bulur {
   color: #409eff;
   border: none;
   --el-button-bg-color: none;
   --el-button-hover-bg-color: none;
   --el-button-hover-text-color: none;
}

.bulur:hover {
   color: #a0cfff;
}

::v-deep .el-table__inner-wrapper::before {
   width: 0;
}

::v-deep .el-table .el-table__cell {
   padding-top: 15px;
   padding-bottom: 15px;
}

.el-card.is-always-shadow {
   width: 95%;
   padding-left: 20px;
   padding-right: 20px;
   padding-bottom: 20px;
}

::v-deep .el-card__body {
   padding: 0;
}

.tabulation {
   margin-top: 10px;
   display: flex;
   justify-content: center;
   align-items: center;
   margin-bottom: 10px;
}
</style>
